export interface PublicBridgePageData {
  id: string;
  slug: string;
  title: string;
  headline: string;
  headline_text?: string | null;
  subheadline?: string | null;
  button_text: string;
  button_color?: string | null;
  background_theme?: string | null;
  timer_seconds: number;
  meta_pixel_id?: string | null;
  ga4_measurement_id?: string | null;
  tenant_name: string;
  primary_color: string;
  secondary_color: string;
  logo_url?: string | null;
  privacy_policy_url?: string | null;
  active_group_id?: string | null;
  active_group_name?: string | null;
  active_group_invite_link: string;
  current_members: number;
  max_capacity: number;
  show_showcase_link?: boolean;
  theme_preference?: 'system' | 'light' | 'dark';
  tenant_slug?: string;
}

const API_BASE = '/api/bridge-pages/public';

export async function fetchPublicBridgePage(
  slug: string
): Promise<PublicBridgePageData> {
  const cleanSlug = encodeURIComponent(slug.trim().toLowerCase());
  const res = await fetch(`${API_BASE}/${cleanSlug}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || 'Página ponte não encontrada ou inativa.');
  }

  return res.json();
}

export async function recordPublicBridgeClick(
  slug: string,
  groupId?: string | null,
  extra?: { eventId?: string | null; eventSourceUrl?: string | null }
): Promise<void> {
  const cleanSlug = encodeURIComponent(slug.trim().toLowerCase());
  const url = groupId
    ? `${API_BASE}/${cleanSlug}/click?group_id=${encodeURIComponent(groupId)}`
    : `${API_BASE}/${cleanSlug}/click`;

  const bodyPayload: Record<string, string> = {};
  if (groupId) bodyPayload.group_id = groupId;
  if (extra?.eventId) bodyPayload.event_id = extra.eventId;
  if (extra?.eventSourceUrl)
    bodyPayload.event_source_url = extra.eventSourceUrl;

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body:
      Object.keys(bodyPayload).length > 0
        ? JSON.stringify(bodyPayload)
        : undefined,
  }).catch(() => {
    // Falha silenciosa para não prender o redirecionamento do usuário
  });
}
